import { CommonContentContext } from '@/utils/context/commonContent/CommonContentContext';
import { UserRole } from '@/utils/interfaces/common/UserRole.enum';
import { useContext, useEffect } from 'react';

export default function RoleGuard({
  requiredRoles,
  children,
  fallback = null,
}: {
  requiredRoles: UserRole[];
  children: React.ReactNode;
  fallback?: React.ReactNode | (() => void);
}) {
  const { userProfile } = useContext(CommonContentContext);

  const hasRole = (!!userProfile || userProfile === UserRole.SuperAdmin) && requiredRoles.includes(userProfile);

  useEffect(() => {
    if (!hasRole && typeof fallback === 'function') {
      fallback();
    }
  }, [hasRole, fallback]);

  if (!userProfile && userProfile !== UserRole.SuperAdmin) {
    return null;
  }

  if (!hasRole) {
    if (typeof fallback !== 'function') {
      return <>{fallback}</>;
    }
    return null;
  }

  return <>{children}</>;
}
